import { Location } from 'history';

export class URLHelper {
    static getQueryParam = (param: string) => new URLSearchParams(window.location.search).get(param);

    static toRelativeURL = (location: Location) => location.pathname + location.search + location.hash;
}
